import { render, staticRenderFns } from "./turnover-list.vue?vue&type=template&id=41a852da&scoped=true&"
import script from "./turnover-list.vue?vue&type=script&lang=ts&"
export * from "./turnover-list.vue?vue&type=script&lang=ts&"
import style0 from "./turnover-list.vue?vue&type=style&index=0&id=41a852da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a852da",
  null
  
)

export default component.exports